import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantBids from './tenant-bids';
import TenantBidsDetail from './tenant-bids-detail';
import TenantBidsUpdate from './tenant-bids-update';
import TenantBidsDeleteDialog from './tenant-bids-delete-dialog';

const TenantBidsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantBids />} />
    <Route path="new" element={<TenantBidsUpdate />} />
    <Route path=":id">
      <Route index element={<TenantBidsDetail />} />
      <Route path="edit" element={<TenantBidsUpdate />} />
      <Route path="delete" element={<TenantBidsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantBidsRoutes;
